import { getUserDetails } from '../../../services/microsoft/graphService';

export const SET_USER = 'SET_MS_USER';

export const EST = 'Eastern Standard Time'

export const setUser = user => ({ type: SET_USER, user });

export const loadUser = () => async dispatch => {
  const userDetails = await getUserDetails();
  const { id, givenName, displayName, mailboxSettings, mail, surname, userPrincipalName } =
    userDetails;

  // Use Fallback timeZone if not found
  const timeZone = mailboxSettings?.timeZone ? mailboxSettings.timeZone : EST;
  const timeFormat = mailboxSettings?.timeFormat ? mailboxSettings.timeFormat : EST;

  dispatch(
    setUser({
      displayName,
      email: mail || userPrincipalName,
      givenName,
      id,
      surname,
      timeFormat,
      timeZone,
    }),
  );
};
